import { SelectDatePaginatorStyle } from './SelectDatePaginatorStyle'
import { SelectMonthSimple } from './SelectMonthSimple'
import { SelectYearSimple } from './SelectYearSimple'

export const SelectDayjs = {
  SelectDatePaginatorStyle,
  SelectMonthSimple,
  SelectYearSimple,
}
